// Main TFCC Website Structure
import TfccLayout from "@/layout/TfccLayout"

// TFCC Web Pages
import HomePage from "@/pages/HomePage"
import Adults from "@/pages/adults/Adults"
import Selection from "@/pages/adults/Selection"
import Juniors from "@/pages/juniors/Juniors"
import Training from "@/pages/juniors/Training"
import OurCoaches from "@/pages/juniors/OurCoaches"
import FixturesResults from "@/pages/FixturesResults"
import About from "@/pages/about/About"
import OurMission from "@/pages/about/OurMission"
import OurFacilities from "@/pages/about/OurFacilities"
import YourCommittee from "@/pages/about/YourCommittee"
import ClubMark from "@/pages/about/ClubMark"
import Gallery from "@/pages/about/Gallery"
import NewsHome from "@/pages/news/NewsHome"
import NewsArticle from "@/pages/news/NewsArticle";
import ContactUs from "@/pages/Contact"
import Register from "@/pages/Register"

const routes = [
    {
        path: '/',
        component: TfccLayout,
        children: [
            {
                path: '/',
                name: 'Home',
                component: HomePage,
                props: true
            },
            {
                path: '/adults',
                name: 'Adults',
                component: Adults,
                props: true
            },
            {
                path: '/selection',
                name: 'Selection',
                component: Selection,
                props: true
            },
            {
                path: '/juniors',
                name: 'Juniors',
                component: Juniors,
                props: true
            },
            {
                path: '/training',
                name: 'Training',
                component: Training,
                props: true
            },
            {
                path: '/our-coaches',
                name: 'Our Coaches',
                component: OurCoaches,
                props: true
            },
            {
                path: '/fixtures-results',
                name: 'Fixtures & Results',
                component: FixturesResults,
                props: true
            },
            {
                path: '/about',
                name: 'About Us',
                component: About,
                props: true
            },
            {
                path: '/our-mission',
                name: 'Our Mission',
                component: OurMission,
                props: true
            },
            {
                path: '/our-facilities',
                name: 'Our Facilities',
                component: OurFacilities,
                props: true
            },
            {
                path: '/your-committee',
                name: 'Your Committee',
                component: YourCommittee
            },
            {
                path: '/club-mark',
                name: 'Club Mark & Policies',
                component: ClubMark,
                props: true
            },
            {
                path: '/gallery',
                name: 'Gallery',
                component: Gallery,
                props: true
            },
            {
                path: '/news',
                name: 'News',
                component: NewsHome,
                props: true
            },
            {
                path: '/news/article',
                name: 'News Article',
                component: NewsArticle,
                props: true
            },
            {
                path: '/contact',
                name: 'Contact Us',
                component: ContactUs,
                props: true
            },
            {
                path: '/register',
                name: 'Register',
                component: Register,
                props: true
            }
        ]
    },
    {
        path: '*',
        redirect: {
            name: 'Home',
            params: {
                responseCode: 301
            }
        }
    }
];

export default routes;
